import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import CancelIcon from '@material-ui/icons/Cancel';
import { getTransactionState } from '../../../store/global/selectors';
import { setDrawEvent, setDrawNestedTransaction, setDrawReuseTransaction, setDrawTemplateTransaction } from '../../../store/global/actions';
import './style.css';
const useStyles = makeStyles((theme) => ({
  backgroundStyle: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    bottom: 12,
    right: 75,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    marginRight: 10,
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function DisableDrawingModeButton({ enable }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const transactionState = useSelector(getTransactionState);





  useEffect(() => {
    let { drawEvent, drawNestedTransaction, drawReuseTransaction, drawTemplateTransaction } = transactionState;
    let status = !drawEvent && !drawNestedTransaction && !drawReuseTransaction && !drawTemplateTransaction;
    setDisabled(status);
  }, [transactionState]);

  const setDrawingModeOff = () => {
    console.log("======drawing mode off===",)

    dispatch(setDrawEvent(false));
    dispatch(setDrawNestedTransaction(false));
    dispatch(setDrawReuseTransaction(false));
    dispatch(setDrawTemplateTransaction(false));
    enable();
  };

  return (
    <div className={classes.backgroundStyle}>
      <div className={classes.root} data-ui-tour-id='df-draw-mode'>
        {disabled && (
          <Fab variant="extended" disabled color="primary">
            <CancelIcon className={classes.extendedIcon} />
            Drawing mode off
          </Fab>
        )}

        {!disabled && (
          <Fab variant="extended" color="primary" onClick={setDrawingModeOff}>
            <CancelIcon className={classes.extendedIcon} />
            Turn off drawing mode
          </Fab>
        )}
      </div>
    </div>
  );
}
